import axios from '../utils/axios'
import { api } from '../config'

export default {
  post (url, data) {
    return axios.post(`${api}${url}`, data)
      .then(response => response.data)
  }
}
